// extracted by mini-css-extract-plugin
export default {"container":"CashOrderModal_container__d0ex-","form":"CashOrderModal_form__3U5RB","operator":"CashOrderModal_operator__A35h-","button":"CashOrderModal_button__QBqOL"};